/**
 * Directive: resourceFieldDetail
 */
angular.module('acme.common.directive.resourceFieldDetail', [
  'acme.common.service.helpers'
])
.directive('resourceFieldDetail', [ 'HelpersService', function(HelpersService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/resourceField/detail/detail.tpl.html',
      scope: {
        field: '=',
        entity: '=',
        fieldIndex: '@fieldindex',
        resourceTemplateId: '@resourcetemplateid',
        disableEdit: '@disableedit'
      },
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.resourceFieldDetail = {

          hasDefaultValue: false,

          edit: function() {
            if (!$scope.disableEdit) {
              $scope.$emit('resourceField::stateChange', { state: 'edit' });
            }
          },

          remove: function() {
            $scope.$emit('resourceFieldDetail::remove', { field: $scope.field, index: $scope.fieldIndex });

          },

          getStringArrayValue: function() {
            console.log(typeof($scope.field.stringArrayValue), $scope.field.stringArrayValue);
            return (typeof($scope.field.stringArrayValue) === 'string') ? HelpersService.stringToArray($scope.field.stringArrayValue) : $scope.field.stringArrayValue;
          },

          getFieldValue: function(field) {
            var value = HelpersService.getFieldValue(field, true);

            this.hasDefaultValue = (value);
console.log(this.hasDefaultValue);
            return (this.hasDefaultValue) ? value : 'No Default Value';
          },

          getFieldType: function(field) {
            console.log(HelpersService.getFieldType(field));
            return HelpersService.cap(HelpersService.getFieldType(field).simpleType);
          }


        };

      }]

    };

}]);